module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/title.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('b', [_vm._v("Sharlene Frances")]), _c('br'), _vm._v("Writing From the Heart")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "publish"
  }, [_c('i', [_vm._v("8370 Eleusis Drive, Anchorage, Alaska 99502-4630"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:books@publicationconsultants.com"
    }
  }, [_vm._v("books@publicationconsultants.com")]), _vm._v("—"), _c('a', {
    attrs: {
      "href": "http://www.publicationconsultants.com",
      "target": "_blank"
    }
  }, [_vm._v("www.publicationconsultants.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f432353","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title.vue
// module id = 57
// module chunks = 0